import React, { useContext, useEffect, useState } from 'react'
import ProductContext from '../context/ProductContext'
import FormattedPrice from '@components/FormattedPrice'
import { checkVariantAvailability } from '../../../utils/misc'
import QuantityInputField from './QuantityInputField'
// import { useTranslation } from 'react-i18next'

const ProductPrice = () => {
  // const { t } = useTranslation()
  const { selectedVariant, formValues, formMethods, priceRange, maxQuantity, isWholesale } = useContext(ProductContext)
  const [jump, setJump] = useState(false)

  const quantity = formValues.quantity || 1

  useEffect(() => {
    setJump(true)
    const t = setTimeout(() => setJump(false), 1000)
    return () => clearTimeout(t)
  }, [priceRange?.undiscount?.min * quantity])

  if (!priceRange) return null

  const isPriceRange = priceRange.discount.min !== priceRange.discount.max
  const priceCurrency = priceRange.currency

  const sale = priceRange.discount.max < priceRange.undiscount.max

  // const rewardProgram = product?.rewardPrograms && product.rewardPrograms[0]
  // let totalRewardPointsMin = 0
  // let totalRewardPointsMax = 0
  // if (rewardProgram) {
  //   totalRewardPointsMin = priceRange.discount.min * rewardProgram.coefficient * quantity
  //   totalRewardPointsMax = priceRange.discount.max * rewardProgram.coefficient * quantity
  // }

  // For kits `quantity` is the number of kits: every add-to-cart path (fixed kit, default kit and
  // "Customize the KIT") passes it on. Supply part stock is checked by the backend per kit count.
  // Wholesale buys copies of digital patterns too.
  const showQuantityField =
    selectedVariant && (isWholesale || selectedVariant.shippingRequired) && checkVariantAvailability(selectedVariant)

  return (
    <div className='my-30'>
      <div className='flex items-center justify-between mb-8'>
        <div>{showQuantityField && <span className='font-medium text-15'>Quantity</span>}</div>
        <span className='text-15 line-through'>
          {!!sale && (
            <>
              {isPriceRange ? (
                <>
                  <FormattedPrice currency={priceCurrency} amount={priceRange.undiscount.min * quantity} /> -{' '}
                  <FormattedPrice currency={priceCurrency} amount={priceRange.undiscount.max * quantity} />
                </>
              ) : (
                <FormattedPrice currency={priceCurrency} amount={priceRange.undiscount.min * quantity} />
              )}
            </>
          )}
        </span>
      </div>
      <div className='flex items-center justify-between'>
        <div>
          {showQuantityField ? (
            <QuantityInputField
              quantity={formValues.quantity}
              availableQuantity={maxQuantity}
              onChangeQuantity={formMethods.onChangeQuantity}
              cartQuantity={selectedVariant.stockQuantity}
              canZero={false}
            />
          ) : (
            <div className='text-15 text-gray'>
              {formValues.quantity} piece{formValues.quantity > 1 ? 's' : ''}
            </div>
          )}
        </div>
        <span
          className={`text-32 font-semibold price ${!!sale ? 'text-red' : 'text-black'} ${jump ? 'price--jump' : ''}`}
        >
          {isPriceRange ? (
            <>
              <FormattedPrice currency={priceCurrency} amount={priceRange.discount.min * quantity} /> -{' '}
              <FormattedPrice currency={priceCurrency} amount={priceRange.discount.max * quantity} />
            </>
          ) : (
            <FormattedPrice currency={priceCurrency} amount={priceRange.discount.min * quantity} />
          )}
        </span>
      </div>
    </div>
  )
}

export default ProductPrice
